import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router"
import { FormGroup, FormControl } from '@angular/forms';
import { ScheduleService } from '../../services/schedule.service';
import {NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import { GlobalVariables } from "../../common/global-variables";

@Component({
  selector: 'app-schedule-timetable',
  templateUrl: './schedule-timetable.component.html',
  styleUrls: ['./schedule-timetable.component.css']
})
export class ScheduleTimetableComponent implements OnInit {


  public route_id: string = "1";
  public direction_id: string = "0";
  public selected_date: string = "Today";
  public selected_service_id: string = "";
  public selected_special_service: Boolean = false;
  public calendar: any;
  public route_service: any;
  public timetable: any;
  public stops: any[];
  public first_stop: any = "";

  public service_ids: any;
  public pdfUrl: string = GlobalVariables.pdfScheduleUrl;

  public formGroup = new FormGroup({});
  model: NgbDateStruct;

  constructor(private router: Router, private route: ActivatedRoute, private scheduleService: ScheduleService) {
    this.route_id = this.route.snapshot.paramMap.get('route');
    if(this.route.snapshot.paramMap.get('direction')){
      this.direction_id = this.route.snapshot.paramMap.get('direction');
    }

    if(this.route.snapshot.paramMap.get('date')){
      this.selected_date = this.route.snapshot.paramMap.get('date');;
    }
    else{
      this.selected_date = this.scheduleService.get_date();
    }

    this.pdfUrl = this.pdfUrl + this.route_id + '.pdf'
   }

  ngOnInit(): void {
    this.scheduleService.get_serivce().subscribe((data) => {

      this.calendar = data["calendar"];
      this.route_service = data["route_service"];

      var valid_service_id = this.route_service[this.route_id];
      var active_service_id: any[] = data["calendar"][this.selected_date]["service_id"];
      this.selected_special_service = data["calendar"][this.selected_date]["special"];

      for(const service_id of valid_service_id){
        if(active_service_id.includes(service_id)){

          this.selected_service_id = service_id;

          this.scheduleService.get_timetable(this.route_id, service_id, this.direction_id).subscribe((data) => {
            this.timetable = data;

            this.stops = data[0];
            this.first_stop = data[0][0];
            this.timetable = data[1];
          });
        }
      }
    });

    
    var date = this.selected_date;

    this.formGroup.addControl("date-select", new FormControl({day:Number(date.substr(6,2)), month:Number(date.substr(4,2)), year:Number(date.substr(0,4))})) //nice
    this.formGroup.valueChanges.subscribe(val => {
      var year = val["date-select"]["year"]
      var month = val["date-select"]["month"]
      var day = val["date-select"]["day"]

      if(month < 10){
        month = "0" + String(month);
      }

      if(day < 10){
        day = "0" + String(day);
      }

      var selected_date = String(year) + String(month) + String(day);

      this.selected_date = selected_date

      this.router.navigateByUrl('schedule/timetable/' + this.route_id + '/' + this.direction_id + "/" + this.selected_date);

      this.get_timetables(selected_date);
    });
  }

  public get_timetables(date: string){
    this.scheduleService.get_serivce().subscribe((data) => {

      this.calendar = data["calendar"];
      this.route_service = data["route_service"];

      var valid_service_id = this.route_service[this.route_id];
      var active_service_id: any[] = data["calendar"][date]["service_id"];
      this.selected_special_service = data["calendar"][this.selected_date]["special"];

      for(const service_id of valid_service_id){
        if(active_service_id.includes(service_id)){

          this.selected_service_id = service_id;

          this.scheduleService.get_timetable(this.route_id, service_id, this.direction_id).subscribe((data) => {
            this.timetable = data;

            this.stops = data[0];
            this.first_stop = data[0][0];
            this.timetable = data[1];
          });
        }
      }
    })
  }

  public load_timetable(direction){
    this.direction_id = direction;

    this.scheduleService.get_timetable(this.route_id, this.selected_service_id, this.direction_id).subscribe((data) => {
      this.timetable = data;

      this.stops = data[0];
      this.first_stop = data[0][0];
      this.timetable = data[1];
    });
  }
}
